import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MarketCatalogFamily, MarketCatalogBilan } from '../../../core/services/prevention-catalog.service';

interface BilanFamilyGroup {
  family: MarketCatalogFamily;
  bilans: MarketCatalogBilan[];
}

/**
 * Sélecteur de bilans réutilisable (Lot 9.0-E.E.D) -- groupé par CatalogFamily, jamais un affichage
 * CATALOG_ONLY/recommendationEnabled/Need/medicalTier/coveredNeeds (section 13 du lot, le CRUD
 * commercial ne réimplémente jamais la gouvernance médicale interne). `disabled` verrouille TOUTE
 * interaction (offre active sur ≥1 site, section 20) -- checkboxes réellement `disabled`, jamais un
 * simple style visuel qu'un clic pourrait encore déclencher.
 */
@Component({
  selector: 'app-bilan-picker',
  standalone: true,
  imports: [],
  templateUrl: './bilan-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bilan-picker.component.scss'],
})
export class BilanPickerComponent {
  @Input() families: MarketCatalogFamily[] = [];
  @Input() bilans: MarketCatalogBilan[] = [];
  @Input() selectedCodes: string[] = [];
  @Input() disabled = false;
  @Output() toggleBilan = new EventEmitter<string>();

  /** Groupé par famille (position croissante), familles sans bilan masquées -- même logique que PreventionBilanCatalogComponent. */
  get groupedByFamily(): BilanFamilyGroup[] {
    return this.families
      .slice()
      .sort((a, b) => a.position - b.position)
      .map(family => ({ family, bilans: this.bilans.filter(b => b.familyCode === family.code) }))
      .filter(group => group.bilans.length > 0);
  }

  isSelected(code: string): boolean {
    return this.selectedCodes.includes(code);
  }

  onToggle(code: string): void {
    if (this.disabled) return;
    this.toggleBilan.emit(code);
  }
}
